import { Button, Col, Form, Input, Row } from "antd";
import { FOOTER_LOGO } from "assets";
import { useNavigate } from "react-router-dom";

const PageFooter = () => {
  const navigate = useNavigate();

  const handleNavigation = (link) => () => {
    navigate(link);
  };

  return (
    <footer className="page-footer">
      <div className="container">
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={6} className="footer-logo">
            <img src={FOOTER_LOGO} alt="" />
            <div className="contact-info">
              <p>9 Ellingwood Court</p>
              <p>Markham, ON, L3R8A8</p>
              <p>Canada</p>
              <p>+92-42-2569358</p>
              <p>+92-336-2569358</p>
            </div>
          </Col>
          <Col xs={24} sm={18}>
            <Row gutter={[20, 30]}>
              <Col xs={12} sm={12} lg={8}>
                <TopFive handleNavigation={handleNavigation} />
              </Col>
              <Col xs={12} sm={12} lg={8}>
                <Resources />
              </Col>
              <Col xs={24} sm={12} lg={8}>
                <Subscribe />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

const Resources = () => (
  <div className="resources">
    <h3 className="blue-heading letter-spacing-4">RESOURCES</h3>
    <h4 className="light-blue-heading letter-spacing-2">FREE COURSES</h4>
    <div className="resources-text-wrapper">
      <p className="m-0">How to Sell on Etsy</p>
      <p className="m-0">Eyst PPC Playbook</p>
    </div>
    <h4 className="light-blue-heading letter-spacing-2">HOW-TO</h4>
    <div className="resources-text-wrapper">
      <p className="m-0">Seller Podcast: Follow the Data</p>
    </div>
  </div>
);

const TopFive = ({ handleNavigation }) => (
  <div className="top-five">
    <h3 className="blue-heading letter-spacing-4">TOP FIVE</h3>
    <h4 className="light-blue-heading letter-spacing-2">TOOLS</h4>
    <div className="tools-wrapper">
      {tools.map((tool) => (
        <p
          className="m-0"
          key={tool.title}
          onClick={handleNavigation(tool?.link)}
        >
          {tool?.title}
        </p>
      ))}
    </div>
  </div>
);

const Subscribe = () => (
  <div className="subscribe">
    <h3 className="blue-heading letter-spacing-4">SUBSCRIBE</h3>
    <p>Subscribe use for newlestter</p>
    <Form>
      <Form.Item>
        <Input placeholder="Enter your Email" />
      </Form.Item>
      <Button type="primary">Submit</Button>
    </Form>
  </div>
);

const tools = [
  { title: "Main Searching", link: "/auth/login" },
  { title: "Product Searching", link: "/auth/login" },
  { title: "Events Calendar", link: "/auth/login" },
  { title: "Profit Calculator", link: "/auth/login" },
  { title: "Comparisons", link: "/auth/login" },
];

export default PageFooter;
